import React, {useState, useEffect} from 'react';
import classnames from 'classnames';
import AbstractModalView from 'common/components/AbstractModalView';
import SimplePreview from '../SimplePreview';
import FormPreview from '../FormPreview';
import FormPreviewLite from '../FormPreviewLite';
import AnimatedUploadingFilePopUp from '../AnimatedUploadingFilePopUp';
import styles from './styles.module.scss';

const ImagePreview = ({
                        id = '0',
                        Button,
                        image,
                        formInitialValues,
                        onOpen,
                        onConfirm,
                        onReject,
                        loading,
                        closeParentModal,
                        pdf,
                        formFields
                      }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const handleOpenModal = (openModal, /*closeModal*/) => e => {
    if (onOpen) {
      onOpen();
    }
    openModal();
  };

  const handleCancel = closeModal => () => {
    if (onReject) {
      onReject();
    }
    closeModal();
  };

  const handleConfirm = closeModal => payload => {
    if (onConfirm) {
      onConfirm(image, payload);
    }
    closeModal();
    closeParentModal();
  };

  useEffect(() => {
    getImageSrc(image);
  }, [image]);

  const getImageSrc = image => {
    switch (typeof image) {
      case 'string':
        setImageSrc(image);
        break;
      case 'object':
      default:
        readDataURL(image);
    }
  };

  const readDataURL = file => {
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
    };
    reader.onerror = function (error) {
      setImageSrc(null);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const getPreview = (closeModal) => {
    const props = {
      pdf,
      imageSrc,
      formInitialValues,
      onConfirm: handleConfirm(closeModal),
      onReject: handleCancel(closeModal)
    }
    switch (formFields) {
      case 'freeTextAndFloors':
        return <FormPreview{...props}/>
      case 'onlyFreeText':
        return <FormPreviewLite{...props}/>
      default:
        return <SimplePreview{...props}/>
    }
  };

  return (
    <>
      <AnimatedUploadingFilePopUp show={loading}/>
      <AbstractModalView
        subPath={`image-preview-${id}`}
        triggerContent={({openModal, closeModal}) => (
          <Button
            onClick={handleOpenModal(openModal, closeModal)}
            openModal={openModal}
            closeModal={closeModal}
          />
        )}
        modalContent={({closeModal}) => (
          <div className={classnames(styles.modalContentContainer, {[styles.pdfContainer]: pdf})}>
            {getPreview(closeModal)}
          </div>
        )}
        onCloseModal={onReject}
        modalClassName={styles.modal}
      />
    </>
  );
};

export default ImagePreview;